import { request } from '@/utils';
import { UnionBadge } from '@/views/Badge';
import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { useQuery } from 'react-query';

const useBadgeName = ({ id, isOfficial }: { id: string; isOfficial: boolean }) => {
  const url = isOfficial ? '/official_badge' : '/badge';
  const select = useCallback(({ badge }: { badge: UnionBadge }) => {
    return badge?.name;
  }, []);

  return useQuery(
    ['badge-name', url, id],
    () => {
      return request.get<{ badge: UnionBadge }>(url, { id });
    },
    {
      select,
      enabled: !!id,
    },
  );
};

export const useEligibilityBadgeName = ({
  badgeEligibility,
}: {
  badgeEligibility?: { badge_ids?: number[]; official_badge_ids?: number[] };
}) => {
  const badgeId = badgeEligibility?.badge_ids?.[0] || badgeEligibility?.official_badge_ids?.[0];
  const isOfficialBadge = !!(badgeId && !isEmpty(badgeEligibility?.official_badge_ids));
  const { data: badgeName } = useBadgeName({
    id: badgeId ? String(badgeId) : '',
    isOfficial: isOfficialBadge,
  });
  return badgeName;
};
